import { TIMEOUT_ERROR } from '@kaltura-ott/tvpil';

import { RhinoError } from '../rhino/error/error';

export function convertRhinoErrorToTvpil(error: any) {
  if (!(error instanceof RhinoError)) {
    return;
  }

  if (error.code === 'NETWORK_ERROR') {
    // @ts-expect-error tvpil-rhino compatibility
    error.code = 'client::request-network-error';
  }

  if (error.code === 'TIMEOUT') {
    // @ts-expect-error tvpil-rhino compatibility
    error.code = TIMEOUT_ERROR;
  }

  if (error.code === 'NETWORK_API_ERROR') {
    // @ts-expect-error tvpil-rhino compatibility
    error.code = error.context?.nativeError.code;
  }
}
